import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/ROC/ROCKFORD_FASTENER_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';
import { TermsAndConditions } from '@ui/pdfs/customer-quote/components/TermsAndConditions';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLine } from './components/QuoteLine';
import { EstimatedQuantityOnHand } from './components/QuoteLine/EstimatedQuantityOnHand';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const ROC_SITE_INFORMATION = [
  '725 South St.',
  'Rockford, IL 61102',
  'Phone: (815) 968 - 5343',
];

export function ROCQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo source={logo} />

        <SiteInformation
          name={['MW Components', 'Rockford Fastener']}
          items={ROC_SITE_INFORMATION}
        />

        {/* Some sites may have a different ecommerce site */}
        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation showFOB />
      </QuoteDetails>

      <View style={styles.row}>
        <View
          style={[
            styles.fullRow,
            styles.italic,
            { marginTop: 0, fontSize: '9px' },
          ]}
        >
          <Text>Comments:</Text>
          <Text>
            Please advise the certification you require at the time of order
            this will be billed as a separate line level & will be sent with the
            shipment unless otherwise specified
          </Text>
          <Text>PKG 1-Certification of Compliance $25.00</Text>
          <Text>
            PKG 2-Full Certification with Material and Subcontractors Certs
            $240.00
          </Text>
          <Text>
            PKG 3-Full Certification with Material and Subcontractors Certs plus
            Dimensional Layout $275.00
          </Text>
          <Text>PKG 4-EFG Standard PPAP level III - $525</Text>
          <Text>
            PKG 5-Customer Specific PPAP Level III = Quoted per request
          </Text>

          <Text>
            PLEASE SEND ALL PURCHASE ORDERS TO: rfisales@mwcomponents.com.
            Quoted lead-time is subject to change based on capacity at the time
            of purchase order receipt
          </Text>

          <Text>Please reference the quote# on the PO.</Text>
          <Text>
            Please reference the Revision for the part. If no revision is
            provided the part will be made to the last revision produced.
          </Text>
        </View>
      </View>

      {quoteLines.map((line) => {
        return (
          <QuoteLine key={line.id} {...line} showDrawing>
            <PartId {...line.part} />

            {/* Most site display description */}
            <PartDescription description={line.part.description} />

            <PartSpecs specs={line.specs} />

            {/* Most sites do not display quantity */}
            <EstimatedQuantityOnHand />
          </QuoteLine>
        );
      })}

      <Specs />

      <EmployeeInformation />

      {/* The rest of this is completely custom per site */}

      <View style={styles.row}>
        <View style={[styles.fullRow, styles.italic, { fontSize: '9px' }]}>
          <Text>I.F.I. Standards Prevail Unless Otherwise Noted</Text>
          <Text>
            ADD’L CHARGES APPLY FOR PPAP/Material Surcharges may apply
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.fullRow, { marginTop: 0, marginBottom: 4 }]}>
          <Text style={[styles.textCenter, styles.bold, styles.uppercase]}>
            Quote Valid for 30 Days
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.fullRow, { marginTop: 0 }]}>
          <TermsAndConditions
            style={[styles.textCenter, styles.bold, styles.underline]}
          />
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.fullRow, styles.textSmall, styles.bold]}>
          <Text>
            • Industry standards allow for a +/- 10% quantity variance.
          </Text>
          <Text>• Prices are stated in US currency.</Text>
          <Text>
            • Prices are based on shippin total orders. Otherwise,
            release-quantity price will prevail.
          </Text>
          <Text>• Print approval required prior to production.</Text>
          <Text>• Expected delivery option may be available upon request.</Text>
          <Text>
            • Estimated lead time is based on material/capacity at time of
            quote. Actual lead time may vary and will be based on
            material/capacity at time of order. MW Components continues to
            experience extended and worsening delays on materials both domestic
            and imported. It is necessary to inform you as it Impacting delivery
            times of orders and shipments. We are doing everything we can to
            manage during this unprecedented time, but these delays are not
            controllable and part of the well published constrained global
            supply chain. As such, MW Components will not be liable for
            expedited shipping and other impacted costs related to these
            concerns.
          </Text>
        </View>
      </View>
    </Page>
  );
}
